// Simple content for demo
module.exports = {
  variant: 'cta',
  label: 'Call to action link',
  href: '/example#link-cta',
};
